import { GqlTransactionKind } from '../../../../../../graphql/base-types.graphql';
import React from 'react';

export const Row = ({
  slots: { selection, buyer, seller, newShares, shareRange, pricePerShare, paid, actions, shareClass },
  component: Component,
  kind,
  showShareRange,
}: {
  slots: {
    selection: React.ReactNode;
    buyer: React.ReactNode;
    seller: React.ReactNode;
    shareClass: React.ReactNode;
    // totalShares: React.ReactNode;
    newShares: React.ReactNode;
    shareRange: React.ReactNode;
    pricePerShare: React.ReactNode;
    paid: React.ReactNode;
    actions: React.ReactNode;
  };
  // any is expected here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.ElementType<any, 'td' | 'th'>;
  kind: GqlTransactionKind;
  showShareRange: boolean;
}) => {
  return (
    <tr>
      <Component>{![GqlTransactionKind.Merge, GqlTransactionKind.Split].includes(kind) && selection}</Component>
      <Component>
        {[GqlTransactionKind.Transfer, GqlTransactionKind.Merge, GqlTransactionKind.Unissue].includes(kind) && seller}
      </Component>
      <Component>{![GqlTransactionKind.Merge, GqlTransactionKind.Unissue].includes(kind) && buyer}</Component>
      <Component>{shareClass}</Component>
      {/* <Component align="right"> */}
      {/*   {![TransactionKind.Transfer, TransactionKind.ShareClassConvert, TransactionKind.BlockPartition].includes( */}
      {/*     kind, */}
      {/*   ) && totalShares} */}
      {/* </Component> */}
      <Component align="right">{newShares}</Component>
      {showShareRange && <Component>{shareRange}</Component>}
      <Component align="right">
        {[GqlTransactionKind.Transfer, GqlTransactionKind.Issue, GqlTransactionKind.Unissue].includes(kind) &&
          pricePerShare}
      </Component>
      <Component align="right">
        {[GqlTransactionKind.Transfer, GqlTransactionKind.Issue, GqlTransactionKind.Unissue].includes(kind) && paid}
      </Component>
      <Component align="right">{actions}</Component>
    </tr>
  );
};
